import trackSignedReferralsHero from '@/assets/track-signed-referrals-hero.png'
import Box from '@mui/material/Box'
import { FeatureConfig } from './types'

export enum FeatureKeys {
  TRACK_SIGNED_REFERRALS = 'track-signed-referrals',
}

// Central configuration for all features
export const featureConfigs: Record<string, FeatureConfig> = {
  [FeatureKeys.TRACK_SIGNED_REFERRALS]: {
    expiresAt: new Date('2025-07-05'),
    priority: 10,
    header: (
      <Box sx={{ height: { xs: 75, sm: 125 } }}>
        <Box sx={{ position: 'absolute', top: 0, left: 0, right: 0 }}>
          <img src={trackSignedReferralsHero} alt="Track Signed Cases" />
          <Box
            sx={{
              position: 'absolute',
              bottom: 0,
              left: 0,
              right: 0,
              height: '50%',
              background: 'linear-gradient(to bottom, transparent, white)',
              pointerEvents: 'none',
            }}
          />
        </Box>
      </Box>
    ),
    title: 'Stay on Top of Your Cases',
    body: (
      <>
        Your My Cases page now has <b>Inbound</b>, <b>Outbound</b>, and{' '}
        <b>Signed</b> tabs — so you can track where every case stands and manage
        signed cases in one place.
      </>
    ),
    primaryLabel: 'Check it out',
    primaryAction: () => {
      window.location.href = '/myReferrals'
    },
    secondaryLabel: 'Close',
    learnMoreLink: undefined,
  },
}
